export const REPORT_CREATE = 'REPORT_CREATE';
export const REPORT_CLEAR = 'REPORT_CLEAR';
